$(document).on('mouseover','.is-sub-menu li',function(e){
    $('.is-sub-menu.active').removeClass('active');
    $(e.target).parents('.is-sub-menu').addClass('active');
})
$(document).on('mouseleave','.is-sub-menu li',function(e){
    $('.is-sub-menu.active').removeClass('active');
})

$(document).on('click','#mobile_menu .is-sub-menu',function(e){
    let parentElement = e.target.closest('.is-sub-menu') || e.target;
    if($(parentElement).find('.mega-grandchild-menu').hasClass('open')){
        $('#mobile_menu').find('.mega-grandchild-menu.open').removeClass('open');
    }else{
        $('#mobile_menu').find('.mega-grandchild-menu.open').removeClass('open');
        $(parentElement).find('.mega-grandchild-menu').addClass('open');1
    }

})